export class IsIdle {
    constructor({ 
    //eslint-disable-next-line no-magic-numbers
    timeout = 1000 * 60 * 5, events = ['mousemove', 'scroll', 'keydown', 'mousedown', 'touchstart'], onIdle = () => { }, onActive = () => { }, } = {}) {
        this.timer = null;
        this.idle = false;
        this.idlenessEventsHandler = () => {
            if (this.idle) {
                this.idle = false;
                this.settings.onActive();
            }
            this.resetTimeout();
        };
        this.settings = {
            timeout,
            events,
            onIdle,
            onActive,
        };
    }
    start() {
        this.timeout();
        this.bulkAddEventListener(this.settings.events, this.idlenessEventsHandler);
        return this;
    }
    stop() {
        this.bulkRemoveEventListener(this.settings.events, this.idlenessEventsHandler);
        this.resetTimeout(false);
        return this;
    }
    timeout() {
        this.timer = setTimeout(() => {
            this.idle = true;
            this.settings.onIdle();
        }, this.settings.timeout);
    }
    resetTimeout(keepTracking = true) {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
            if (keepTracking) {
                this.timeout();
            }
        }
    }
    bulkAddEventListener(events, callback) {
        events.forEach((event) => {
            window.addEventListener(event, callback);
        });
    }
    bulkRemoveEventListener(events, callback) {
        events.forEach((event) => {
            window.removeEventListener(event, callback);
        });
    }
}
